import Vuex from 'vuex'
import moduleLogin from './modules/moduleLogin'
/**
 * Módulos do Vuex
 */
import moduleImportShape from "./modules/moduleImportShape"
import moduleMessages from './modules/moduleMessages'
import moduleMapData from "./modules/moduleMapData"
// Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        moduleMessages, 
        moduleLogin,
        moduleMapData, moduleImportShape

    }
    
})